@import '../../../../theme/colors';

.addNavigation {
  font-family: var(--font-family__body);
  display: flex;
  align-items: center;
  form {
    display: flex;
    align-items: center;
  }
  .radioGroupLabel {
    display: none;
  }
  .radioGroup {
    margin-left: 12px;
  }
  .radioLabel {
    margin-right: 20px;
    color: $oceanBlue;
    span:nth-of-type(1) {
      padding: 0;
    }
    span:nth-of-type(2) {
      margin-left: 8px;
      color: $neutral-600;
    }
    &.radioDisabled {
      position: relative;
      span:nth-of-type(2) {
        color: $neutral-300;
      }
      &:after {
        content: 'Dashboard Category must be created before Dashboard';
        position: absolute;
        font-family: Helvetica, sans-serif;
        font-size: 10px;
        font-weight: 300;
        color: $neutral-600;
        left: 0;
        bottom: -14px;
        width: 200%;
      }
    }
  }
  .categoryNameInput {
    width: 290px;
    margin-right: 20px;
  }
  .select.selectDisabled:after {
    content: 'No dashboards available for this client.';
    position: absolute;
    font-family: Helvetica, sans-serif;
    font-size: 10px;
    font-weight: 300;
    color: $neutral-600;
    left: 0;
    bottom: -16px;
  }
}

.navigation {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.navListWrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 769px;
  margin-top: 65px;
  .navListHeader {
    font-family: var(--font-family__heading);
    font-size: 12px;
    color: $neutral-600;
    padding-left: 56px;
    padding-bottom: 8px;
    padding-top: 8px;
    border-bottom: 2px solid $neutral-200;
    p {
      margin: 0;
      padding: 0;
    }
  }
  .navList {
    padding: 0;
  }
  .navListItem {
    padding: 0;
    border-bottom: 1px solid $neutral-200;
    background-color: white;
    .navListDragIcon {
      min-width: 24px;
      width: 24px;
      padding: 16px;
    }
    .navListForm {
      display: flex;
      align-items: center;
      & > div:last-child {
        position: relative;
        top: unset;
        right: unset;
        transform: unset;
        left: 35px;
      }
      input {
        width: 246px;
        height: 28px;
        box-sizing: border-box;
        padding: 6px;
        font-family: var(--font-family__body);
        font-size: 12px;
        line-height: 17px;
        border-color: $neutral-300;
      }
      label {
        font-family: var(--font-family__body);
        font-size: 12px;
        line-height: 17px;
        transform: translate(0.5em, 5px);
      }
    }
  }
  .dashboardList {
    padding: 0;
    margin-left: 56px;
    min-height: 8px;
    transition: background-color 400ms ease;
    &.isDraggingOver {
      background-color: $neutral-200;
    }

    .formControl {
      min-width: 190px;
      max-width: 190px;
    }
  }
}
